<template>
<v-container fluid>
  <v-row>
    <v-col cols="6">
      <v-card>
        <bbsavant></bbsavant>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card>
        <v-radio-group
          v-model="pov"
          mandatory
          row
        >
          <v-radio
            v-for="(radio, i) in povOptions" :key="i"
            :label="radio.text"
            :value="radio.value"
          ></v-radio>
        </v-radio-group>

        <strike-zone-hmap v-model="mappedValues"></strike-zone-hmap>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import merge from "lodash/merge";
import { Providers, Enums, Entities, Converters, ValueObjects } from '@flightscope/baseball-stats';
import { StrikeZoneDataBinning } from '@flightscope/baseball-stats/src/classificators/dataBinning';
import StrikeZoneHmap from '@/components/ui/charts/StrikeZoneHmap.vue';
import { POV, strikeZoneSeriesProvider } from '@/components/ui/charts/strikeZoneHelpers';
import bbsavant from './bbsavant.svg';
import * as data from '@flightscope/baseball-stats/test/data/kia_vs_hanwha_reprocessed.json';

export default {
  components: {
    bbsavant,
    StrikeZoneHmap,
  },

  data() {
    return {
      pov: POV.BATTER,
      povOptions: [
        { value: POV.BATTER, text: 'BATTER POV' },
        { value: POV.PITCHER, text: 'PITCHER POV' }
      ],

      mappedValues: [],
    };
  },

  mounted() {
    const ctx = null;
    const chartSeries = strikeZoneSeriesProvider(ctx, data.Results);

    this.mappedValues = strikeZoneSeriesMapper(ctx, null, [chartSeries]);
  },
};
</script>

<style>
</style>
